module.exports = __webpack_public_path__ + "media/images/lense_nav_search-30925f5aebec0ad6e7a995ed30d745f6.svg";